module.exports = __webpack_public_path__ + "img/lawnlove.f2997ea1.svg";